import { toast } from "@/shared/store/alertStore";

export function resolveServiceNotification(wsPayload) {
  const n = wsPayload?.data || {};
  const isKk = (localStorage.getItem("lang") || "ru") === "kk";
  const title = (isKk ? n.title_kk : n.title) || n.title;
  const description =
    (isKk ? n.description_kk : n.description) || n.description;
  return { title, description };
}

export function showServiceNotification(wsPayload) {
  const { title, description } = resolveServiceNotification(wsPayload);
  if (!title && !description) return;
  const id = wsPayload?.service_code
    ? `svc-notif:${wsPayload.service_code}`
    : undefined;
  toast.info(title || description, {
    id,
    description: title ? description : undefined,
    duration: 6000,
  });
}
